import React from 'react';
import { Sparkle } from '@phosphor-icons/react';
import { CanonicalToolRenderer } from '../../../components/Space/SpaceChat/renderers/canonical/CanonicalToolRendererRegistry';

export const ContactsEnrichRenderer: CanonicalToolRenderer = {
  icon: Sparkle,
  displayName: 'Enrich Contact',
  getVerb: (isExecuting) => (isExecuting ? 'Enriching' : 'Enriched'),

  getHeaderMessage: (context) => {
    const data = context.execution.result?.view?.data;
    if (!data) return null;
    const parts: string[] = [];
    if (data.topics?.length) parts.push(`${data.topics.length} topics`);
    if (data.signals?.length) parts.push(`${data.signals.length} signals`);
    if (data.nextReachOutAt) parts.push('reach-out scheduled');
    return parts.length ? parts.join(' · ') : null;
  },

  shouldResolveEntity: false,
  useEntityIcon: false,
  isNavigable: false,
  defaultExpanded: true,
  supportsStreaming: true,

  renderExecuting: ({ execution }) => {
    const progress = execution.result?.view?.progress || execution.progress || 'Scanning integrations...';
    const data = execution.result?.view?.data || {};

    return (
      <div className="contacts-enrich-renderer contacts-enrich-renderer--executing">
        <p className="contacts-enrich-renderer__progress">{progress}</p>
        {data.topics?.length > 0 && (
          <div className="contacts-enrich-renderer__topics">
            {data.topics.map((t: string) => (
              <span key={t} className="contacts-enrich-renderer__topic-chip">{t}</span>
            ))}
          </div>
        )}
      </div>
    );
  },

  renderCompleted: ({ execution }) => {
    const data = execution.result?.view?.data || {};

    return (
      <div className="contacts-enrich-renderer contacts-enrich-renderer--completed">
        {data.name && (
          <p className="contacts-enrich-renderer__name">{data.name}</p>
        )}
        {data.topics?.length > 0 && (
          <div className="contacts-enrich-renderer__section">
            <span className="contacts-enrich-renderer__label">Topics</span>
            <div className="contacts-enrich-renderer__topics">
              {data.topics.map((t: string) => (
                <span key={t} className="contacts-enrich-renderer__topic-chip">{t}</span>
              ))}
            </div>
          </div>
        )}
        {data.lastInteraction && (
          <div className="contacts-enrich-renderer__section">
            <span className="contacts-enrich-renderer__label">Last interaction</span>
            <span className="contacts-enrich-renderer__value">
              {new Date(data.lastInteraction.at).toLocaleDateString()} via {data.lastInteraction.channel}
              {data.lastInteraction.snippet && ` — ${data.lastInteraction.snippet}`}
            </span>
          </div>
        )}
        {data.nextReachOutAt && (
          <div className="contacts-enrich-renderer__section">
            <span className="contacts-enrich-renderer__label">Reach out by</span>
            <span className="contacts-enrich-renderer__value">
              {new Date(data.nextReachOutAt).toLocaleDateString()}
              {data.nextReachOutReason && ` — ${data.nextReachOutReason}`}
            </span>
          </div>
        )}
        {data.signals?.length > 0 && (
          <div className="contacts-enrich-renderer__section">
            <span className="contacts-enrich-renderer__label">Signals</span>
            {data.signals.map((s: any) => (
              <p key={s.id} className="contacts-enrich-renderer__signal">{s.title}</p>
            ))}
          </div>
        )}
      </div>
    );
  },

  renderError: ({ execution }) => (
    <div className="contacts-enrich-renderer contacts-enrich-renderer--error">
      Enrichment failed: {execution.error}
    </div>
  ),
};
